module.exports = __webpack_public_path__ + "img/1.63a3f8b8.png";